import { render } from "./BrandFutter.vue?vue&type=template&id=13668d53"
import script from "./BrandFutter.vue?vue&type=script&lang=ts"
export * from "./BrandFutter.vue?vue&type=script&lang=ts"

import "./BrandFutter.vue?vue&type=style&index=0&id=13668d53&lang=scss"
script.render = render

export default script